/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnDestroy, OnInit, Optional, Self, SkipSelf } from '@angular/core';
import { SlideAnimation } from '@ng-falcon/ngf-form/+animations/slide-animation';
import { NgfControlError } from '@ng-falcon/ngf-form/ngf-control/ngf-control-error/ngf-control-error';
import { NgfFormService } from '@ng-falcon/ngf-form/ngf-form.service';

@Component({
    selector: 'ngf-control-error',
    templateUrl: './ngf-control-error.component.html',
    styleUrls: ['./ngf-control-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('self', SlideAnimation)
    ],
    standalone: false
})
export class NgfControlErrorComponent implements NgfControlError, OnInit, OnDestroy {
  @HostBinding('@self')
  self;

  constructor(@SkipSelf() readonly container: ElementRef<HTMLElement>,
              @Self() readonly element: ElementRef<HTMLElement>,
              @Optional() private ngfForm: NgfFormService | null) {}

  ngOnInit(): void {
    this.ngfForm?.addError(this);
  }

  ngOnDestroy(): void {
    this.ngfForm?.removeError(this);
  }

}
